import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

// @ts-ignore
const PublicRoute = ({component: Component, restricted, ...rest}) => {
  const { data = {} } = useSelector((state: any) => state.user);
  return (
    // restricted = false meaning public route
    // restricted = true meaning restricted route
    <Route {...rest} render={props => (
      data.access_token && restricted ?
        <Redirect to="/" />
        : <Component {...props} />
    )} />
  );
};

export default PublicRoute;